import styled from "styled-components";

export const NavbarContainer = styled.div`
	display: flex;
	flex-direction: row;
	padding: 20px 60px;
	height: 30px;
	align-items: center;
	justify-content: space-between;
	box-sizing: content-box;

	@media (max-width: 768px) {
		padding: 5px 30px;
		height: 70px;
	}
`;

export const Header = styled.header`
	position: sticky;
	top: 0;
	z-index: 999;
	background-color: rgba(255, 255, 255, 0.94);
	backdrop-filter: blur(8px);
`;

export const Logo = styled.div`
	display: flex;
	align-items: center;
	text-align: center;
	line-height: 30px;
	font-size: 30px;
	margin-left: 10px;
	color: #2572b5;
	font-family: "Arial Rounded MT Bold", "Arial Rounded MT", Arial, sans-serif;

	/* I sould write background-clip: text; and work with -webkit-background-clip: text; automatically */
	background: -webkit-linear-gradient(45deg, #ba6bff, #2572b5);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
`;

export const NavbarButton = styled.span`
	padding: 10px 15px;
	font-size: 22px;
	cursor: pointer;

	color: #666;
	background-color: ${({ selected }) => (selected ? "#DDD" : "transparent")};
	border: 1px solid ${({ selected }) => (selected ? "transparent" : "#ddd")};
	border-radius: 10px;

	@media (max-width: 768px) {
		display: none;
	}

	&:hover {
		color: #000;
		background-color: #eee;
	}
`;

export const MobileMenuContainer = styled.div`
	background-color: #fff;
`;

export const MobileMenuButton = styled.div`
	padding: 15px;
	text-align: center;
	font-size: 22px;
	color: #2572b5;
	border-top: 0.5px solid #aaa;
`;

export const QrImage = styled.div`
	display: flex;
	flex-direction: row;
	z-index: 10;
	transition: all 0.3s ease-in-out;
	border-radius: 35px;
	overflow: hidden;
	width: 350px;
	transform: scale(0.125) translate(0px, 0px);

	@media (max-width: 768px) {
		/* border-radius: 20px;
		transform: scale(0.2) translate(0px, 0px); */
		display: none;
	}

	&:hover {
		transform: scale(1) translate(0px, 150px);
		box-shadow: 0 0 14px #00000077;

		@media (max-width: 768px) {
			transform: scale(1) translate(0px, 60px);
		}
	}
`;

export const NavStoreBadges = styled.div`
	display: flex;
	margin-right: 8px;

	@media (max-width: 1100px) {
		display: none;
	}
`;
